export { default } from './Advantages';
export type { AdvantagesProps } from './Advantages';
